import { Button, Flex, Heading, Icon, Icons, Modal, Paragraph } from "@ir/ui";

interface ResponseModalProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  buttonOnPress?: () => void;
  buttonText?: string;
  children?: React.ReactNode;
  icon?: Icons;
  iconColor?: "success" | "error" | "warning" | "grey" | "inherit" | "primary" | "secondary";
  iconClassName?: string;
  iconStyle?: React.CSSProperties;
  closable?: boolean;
}

const ResponseModal = ({
  isOpen,
  title,
  message,
  buttonOnPress,
  buttonText,
  children,
  icon,
  iconColor,
  iconClassName,
  iconStyle,
  closable = true,
}: ResponseModalProps) => {
  return (
    <Modal isOpen={isOpen} size="medium" hideFooter={true} isDismissible={false} closable={closable} zIndex={92}>
      {children ?? (
        <Flex direction="column" align="center" className="text-center py-4">
          <Icon
            name={icon ?? Icons.CheckCircleWithBg}
            size="large"
            color={iconColor ?? "grey"}
            className={icon ? iconClassName : "without-stroke"}
            style={{ width: "6rem", height: "6rem", ...iconStyle }}
          />
          {title && (
            <Heading level={5} className="mt-3 text-gray-700">
              {title}
            </Heading>
          )}
          {message && <Paragraph className="my-2 text-lg text-grey">{message}</Paragraph>}
          {buttonText && (
            <Button className="mt-4" size="large" variant="outline" onPress={buttonOnPress}>
              {buttonText}
            </Button>
          )}
        </Flex>
      )}
    </Modal>
  );
};

export default ResponseModal;
